import { Bubble, Input, Switch } from 'tea-component';
import html2canvas from 'html2canvas';
import { TemplateGroupRadio } from '../components';
import { useDblIntl } from '@/pages/datalab/utils/utils';
import React, { useCallback, useState } from 'react';
import SvgIcon from '@home/components/SvgIcon';
import { base64toFile } from '@gp/utils/common';
import http from '@/utils/http';
import { RequrstBack } from '@/pages/aigc/types/server';
import { useRequest } from 'ahooks';
import { queryInitStatClientConfig } from '@/pages/aigc/constants/server';
import useCos from '@gp/hooks/useCos';
import { LANGUAGE_CN } from '@home/_config/config';
import { getLocale } from 'umi';
type TFormKey = 'setTemplateModal' | 'setTemplateSaveModal';

type TFormMapKey = {
  searchFormRef: any;
  key: TFormKey;
  isTemplateReport?: string;
};
// 表单配置项
export const useFromConfigMapKey = ({
  searchFormRef,
  key,
  isTemplateReport
}: TFormMapKey) => {
  const { dblFormatMessage, commonFormatMessage, isEn  } = useDblIntl('dashboard_list');
  const config = {
    ['setTemplateModal']: [
      {
        name: 'category',
        label: (
          <div
            style={{
              position: 'relative',
              top: '-8px',
            }}
          >
            {dblFormatMessage('template_type')}
          </div>
        ),
        component: (
          <TemplateGroupRadio
            {...{ searchFormRef, dblFormatMessage, isEn }}
          />
        ),
        rules: { message: '', required: false },
      },
      {
        name: 'template_title',
        label: dblFormatMessage('template_name'),
        component: <Input  size="full" placeholder={dblFormatMessage('template_placeholder')} />,
        rules: { message: '', required: true, validator: (value)=>{
          const keyWord = value.template_title;
          let errorMessageRef = '';
          const tempName = keyWord?.trim();
          const NAME_REGEX = /^[\u4E00-\u9FA5a-zA-Z0-9 _\-()]+$/;
          if (tempName?.length < 1) {
            errorMessageRef = commonFormatMessage('cannot_be_empty');
          } else if (tempName?.length > 50) {
            errorMessageRef = commonFormatMessage("valid_name_length", {count: '50'});
          } else if (!NAME_REGEX.test(tempName)) {
            errorMessageRef = commonFormatMessage("dashboard_valid_name");
          } else errorMessageRef = '';
          
          return errorMessageRef;
        } },
      },
    ],
    ['setTemplateSaveModal']: [
      {
        name: 'dashboard_title',
        label: dblFormatMessage(isTemplateReport ? 'template_name' : 'dashboard_name'),
        component: (
          <Input
            size="full"
            placeholder={dblFormatMessage(isTemplateReport ? 'template_placeholder': 'dashboard_placeholder')}
          />
        ),
        rules: { message: '', required: true, validator: (value)=>{
          const keyWord = value.dashboard_title;
          let errorMessageRef = '';
          const tempName = keyWord?.trim();
          const NAME_REGEX = /^[\u4E00-\u9FA5a-zA-Z0-9 _\-()]+$/;
          if (tempName?.length < 1) {
            errorMessageRef = commonFormatMessage('cannot_be_empty');
          } else if (tempName?.length > 50) {
            errorMessageRef = commonFormatMessage("valid_name_length", {count: '50'});
          } else if (!NAME_REGEX.test(tempName)) {
            errorMessageRef = commonFormatMessage("dashboard_valid_name");
          } else errorMessageRef = '';
          
          return errorMessageRef;
        } },
      },
      {
        name: 'set_as_template',
        label: (
          <div
            style={{
              position: 'relative',
              top: '-10px',
            }}
          >
            {dblFormatMessage('save_template')} &nbsp;
            <Bubble dark content={dblFormatMessage('save_template_icon_info')}>
              <span>
                <SvgIcon className="port-icon" type={'alert-circle-m'} />
              </span>
            </Bubble>
          </div>
        ),
        component: <Switch />,
        rules: { message: '', required: false },
      },
      {
        name: 'category',
        label: (
          <div
            style={{
              position: 'relative',
              top: '-10px',
            }}
          >
            {dblFormatMessage('template_type')}
          </div>
        ),
        component: (
          <TemplateGroupRadio
            {...{ searchFormRef, dblFormatMessage, isEn }}
          />
        ),
        rules: { message: '', required: false },
      },
      {
        name: 'template_title',
        label: dblFormatMessage('template_name'),
        component: <Input placeholder={dblFormatMessage('template_placeholder')} size="full" />,
        rules: { message: '', required: true, validator: (value)=>{
          if(isTemplateReport || !value.set_as_template) return '';
          const keyWord = value.template_title;
          let errorMessageRef = '';
          const tempName = keyWord?.trim();
          const NAME_REGEX = /^[\u4E00-\u9FA5a-zA-Z0-9 _\-()]+$/;
          if (tempName?.length < 1) {
            errorMessageRef = commonFormatMessage('cannot_be_empty');
          } else if (tempName?.length > 50) {
            errorMessageRef = commonFormatMessage("valid_name_length", {count: '50'});
          } else if (!NAME_REGEX.test(tempName)) {
            errorMessageRef = commonFormatMessage("dashboard_valid_name");
          } else errorMessageRef = '';
          
          return errorMessageRef;
        } },
      },
    ],
  };
  return {
    config: config?.[key],
  };
};
// 屏幕快照异步回调hooks
export function useUploadingCaptureEffect(props: {
  title: string;
  node: HTMLElement;
  fileFlag: boolean;
}) {
  const { title, node, fileFlag } = props;
  const [uploading, setUploading] = useState(false);
  const [getResourceFn] = useBase64getCaptureCover();
  const handleDownload = (value?: { fileFormat: string; flag: boolean; }): Promise<void> => new Promise((resolve, reject) => {
    setUploading(true);
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    setTimeout(async () => {
      if (!node) {
        setUploading(false);
        resolve();
        return;
      }
      try {
        const fileFormat = value?.fileFormat || 'image/jpeg';
        const path = await captureNode({
          type: fileFormat as any,
          node,
          fileName: `template -${title}`,
        });
        // 如果外部传入的ref标识变成了false，（只有在上传过程中点击了取消，或者点击模态框右上角的x）说明我们的上传接口是不需要再请求了，这个请求的resolve是不会在抛出了，后续的链式then方法将不执行
        if(fileFlag?.current){
          const res = await getResourceFn(path || '');
          resolve({preview_image_url: res});
        }
      } catch (error) {
        reject(error);
      } finally {
        setUploading(false);
      }
    }, 300);
  });

  return {
    uploading,
    onDownload: handleDownload,
  };
}
// 图片上传cos，并转http格式
export const useBase64getCaptureCover = () => {
  const { putObject, getObjectUrl } = useCos({
    qCouldService: fetchCOSInfo,
    isUseAccelerate: false,
  });
  const getResourceFn = useCallback(async (base64: string) => {
    try {
      const file = base64toFile(base64, `cover${Date.now()}`);
      const pathName = `image/${Date.now()}fileName=${file.name}`;
      // 上传到Cos
      const res = await putObject({
        path: pathName,
        file,
        onProgress: () => {},
      });
      // 拿到图片链接
      const path = await getObjectUrl({ path: pathName });
      if (res?.statusCode === 200) {
        if (path?.url) {
          return path?.url;
        }
      }
    } catch (error) {
      // 在这里捕获错误，确保错误被正确处理
      console.error('[getResourceFn] cos上传失败:', error);
    }
  }, [putObject, getObjectUrl]);
  return [getResourceFn];
};
// 报表设置模板add
export const useSetAsTemplateData = <T,>(params?: T) => {
  const locale = getLocale();
  const language = locale === LANGUAGE_CN ? 'zh' :'en';
  const fetch = (mutateParams: T) =>
    http({
      url: '/api/v1/datalab/custom_report/add',
      method: 'post',
      data: {
        ...mutateParams,
        version: 'v2'
      },
      headers: {
        'accept-language': language,
      },
      ...params
    }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    // refreshDeps: [params],
    cacheKey: 'templateHomeData',
    loadingDelay: 300,
    manual: true,
    retryCount: 0,
  });
  return {
    ...data,
  };
};

export const captureNode = async (cfg: {
  type?: string;
  node: HTMLElement;
  nodeOptions?: any;
  options?: any;
  fileName?: string;
}) => {
  const type = cfg?.type || 'image/jpeg';
  const node = cfg?.node;
  const options = cfg?.options || {};
  const { onClone, ...remainOptions } = options || {};
  const width = parseFloat(getComputedStyle(node).getPropertyValue('width'));
  const canvas = await html2canvas(node || document.body, {
    useCORS: true,
    scale: 0.8,
    imageTimeout: 60 * 1000,
    backgroundColor: '#f2f3f5',
    width,
    height: window.innerHeight,
    ...remainOptions,
  });
  const dataURL = canvas.toDataURL(type, 0.5);
  return dataURL;

};
// 获取COS相关配置，及即将上传的视频的uuid、上传路径
export const fetchCOSInfo = async () => http({
  method: 'GET',
  url: '/api/v1/aigc/tencent_qcloud/auth',
}) as any;